import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function listResearch(limit = 50) {
  const { data } = await client.get('/research', { params: { limit } });
  return data;
}

export async function listInsights() {
  const { data } = await client.get('/research/insights');
  return data;
}

// Crea una investigación propia (persistida en backend, source='custom').
export async function createResearch(payload) {
  const { data } = await client.post('/research', payload);
  return data.item;
}

// Trae una investigación por id (para la página de detalle).
export async function getResearchItem(id) {
  const clean = String(id).replace(/^auto-/, '');
  const { data } = await client.get(`/research/${clean}`);
  return data.item;
}

// Actualiza una investigación propia (in-place).
export async function updateResearch(id, payload) {
  const clean = String(id).replace(/^auto-/, '');
  const { data } = await client.put(`/research/${clean}`, payload);
  return data.item;
}

// Borra una investigación propia.
export async function deleteResearch(id) {
  const clean = String(id).replace(/^auto-/, '');
  const { data } = await client.delete(`/research/${clean}`);
  return data;
}

const researchService = { listResearch, listInsights, createResearch, getResearchItem, updateResearch, deleteResearch };
export default researchService;
